import React, { useEffect } from 'react'
import { useApi } from '../../hooks/useApi'
import { ApiConfig } from '../../config/api'
import axios from 'axios'
import { PickingAlertButton } from '../../pages/PickingRouteAdmin_Context/PickingAlertButton'

interface PickingAlertButtonProps {
  title: string
  onClick: () => void
}

export const getPickingRoutesWithoutStock = () => {
  const url = new URL(`${ApiConfig.StockApi}/GetStockAlerts`)
  return axios.get(url.toString())
}

export const MissingStockAlert: React.FC<PickingAlertButtonProps> = ({
  onClick
}) => {
  const { state, callApi } = useApi<any>()

  const fetchPickingRoutesWithoutStock = () => {
    callApi(getPickingRoutesWithoutStock())
  }

  useEffect(() => {
    fetchPickingRoutesWithoutStock()
  }, [])

  const decideValueToAlert = (totalQuantity: number | undefined) => {
    if (totalQuantity === undefined) {
      return '0 SKU'
    }

    if (totalQuantity === 1) {
      return '1 SKU'
    }

    if (totalQuantity > 100) {
      return '+100 SKU'
    }

    return `${totalQuantity.toString()} SKU`
  }

  return (
    <PickingAlertButton
      title={decideValueToAlert(state.data)}
      onClick={onClick}
    />
  )
}
